import React, { useContext, useEffect, useRef, useState } from 'react';

import { Button, Form, Input, Popconfirm, Table, Typography, DatePicker, Space, message, } from 'antd';
import PageWrapper from "../../helpers/PageWrapper";
import BackButton from "../../helpers/BackButton";
import moment from 'moment';
import { DeleteTwoTone, DownloadOutlined, EditTwoTone } from '@ant-design/icons';
import styles from './style.module.css';
import axios from 'axios';
import { useParams } from 'react-router';
import TokenService from "../../../services/token.service";
import authAxios from "../../../services/api";
const confirm = () => {
  
  message.success('Click on Yes');
};
const LessonPlanPage = () => {
  const [streams, setStreams] = useState([]);
  const { teacherId, streamId } = useParams();
  


  useEffect(() => {
    
    
    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/streams`,{

      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then((response) => {
        setStreams(response.data);
        console.log(streams)
      })
      .catch((err) => {
        console.log(err.message);
      });

  }, []);
  const mergeArrays = (arr1) => {
    return arr1.map((stream) => {

      return stream;
    })
  };

  const mergedArrays = mergeArrays(streams)
  console.log(mergedArrays)
  const [dataSource, setDataSource] = useState(
    [

      streams.map(stream => ({
        key: stream.id,
        stream: stream.name,
        group: stream.group.name,
        teacherName: stream.teacher.name,
        teacherSurname: stream.teacher.surname,
        teacherPatronymic: stream.teacher.patronymic,
        discipline: stream.discipline.name,
      }))

    ]);
  const [count, setCount] = useState(2);



  const defaultColumns = [
   
    {
      title: 'Поток',
      dataIndex: 'stream',
      editable: true,
    },
    {
      title: 'Группа',
      dataIndex: 'group',
      editable: true,
    },
    {
        title: 'Преподаватель',
        dataIndex: 'teacher',
        editable: true,
      },
      {
        title: 'Дисциплина',
        dataIndex: 'discipline',
        editable: true,
      },
    {
      title: 'operation',
      dataIndex: 'operation',
      width: '10%',
      key: "theme",
      render: (_, record) =>
      
        <Space size="middle">
          <Popconfirm placement="topLeft" title={'Вы действительно хотите удалить этот поток?'} onConfirm={() => handleDeleteLesson(record.id)} okText="Yes" cancelText="No">
          <Button className={styles.deleteButton} >
            <DeleteTwoTone twoToneColor="#ff0000" onClick={() => handleDeleteLesson(record.id)} />
          </Button>
         
          </Popconfirm>
        </Space>
        
    },
  ];


  const handleDeleteLesson = (key, e) => {
    
    axios.delete(`http://85.159.27.198:8080/abitur/api/v1/streams/delete?streamId=${key}`,{
      
      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then(res => {
        message.success('Поток удален', 5);
        authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/streams`,{

      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  })
      .then((response) => {
        setStreams(response.data);
        console.log(streams)
      })
      .catch((err) => {
        console.log(err.message);
      });
      }).catch((error) =>  message.error(error, 10));
      
  };

  

  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
       
      }),
    };
  });
  return (
    <PageWrapper>
      
      <Typography.Title level={1}>Все Потоки</Typography.Title>
      
      <Table
        
        rowClassName={() => 'editable-row'}
        bordered
        dataSource={
          mergedArrays.map((stream) => ({
            id: stream.id,
            stream: stream.name,
            group: stream.group.name,
            teacher: stream.teacher.surname +" "+ stream.teacher.name + " " + stream.teacher.patronymic,
           
            discipline: stream.discipline.nameRu + '/' + stream.discipline.name,
          }))
        }
        
        columns={columns}
      />
    </PageWrapper>



  );
};

export default LessonPlanPage;